import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PruefungAllgemeinPage} from "../pruefung-allgemein/pruefung-allgemein";
import {HelpModule} from "../../components/help/help.module";

@NgModule({
  declarations: [
    PruefungAllgemeinPage,
  ],
  entryComponents: [
    PruefungAllgemeinPage,
  ],
  imports: [
    IonicPageModule.forChild(PruefungAllgemeinPage),
    HelpModule,
  ]
})
export class PruefungAllgemeinModule {}



// WEBPACK FOOTER //
// ./src/pages/pruefung-allgemein/pruefung-allgemein.module.ts